import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { LogIn, Lock, User } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

export default function LoginPage() {
  const { login } = useAuth();
  const [identifiant, setIdentifiant] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await login(identifiant, password);
    } catch (err) {
      setError(err.response?.data?.error || 'Connexion impossible');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-cream-100 to-cream-200 flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-gold-400 to-gold-600 flex items-center justify-center mx-auto mb-4 shadow-lg">
            <span className="font-serif text-white text-3xl font-semibold">G</span>
          </div>
          <h1 className="font-serif text-2xl text-navy-900">Hello Georges</h1>
          <p className="text-navy-300 text-sm mt-0.5">Espace de gestion</p>
        </div>

        <form onSubmit={submit} className="bg-white rounded-[22px] shadow-xl p-6 space-y-4">
          <div>
            <label className="block text-[13px] font-medium text-navy-600 mb-1.5">Identifiant</label>
            <div className="relative">
              <User size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-navy-300" />
              <input
                autoFocus
                value={identifiant}
                onChange={e => setIdentifiant(e.target.value)}
                className="w-full pl-9 pr-3 py-2.5 border border-cream-300 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-navy-300 focus:border-transparent"
                placeholder="prénom"
              />
            </div>
          </div>
          <div>
            <label className="block text-[13px] font-medium text-navy-600 mb-1.5">Mot de passe</label>
            <div className="relative">
              <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-navy-300" />
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                className="w-full pl-9 pr-3 py-2.5 border border-cream-300 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-navy-300 focus:border-transparent"
                placeholder="••••••••"
              />
            </div>
          </div>

          {error && (
            <div className="text-[13px] text-red-600 bg-red-50 rounded-lg px-3 py-2">{error}</div>
          )}

          <button
            type="submit"
            disabled={loading || !identifiant || !password}
            className="w-full bg-navy-800 hover:bg-navy-700 text-white py-2.5 rounded-xl font-medium flex items-center justify-center gap-2 transition-colors disabled:opacity-50"
          >
            <LogIn size={16} /> {loading ? 'Connexion…' : 'Se connecter'}
          </button>

          <div className="text-center pt-1">
            <Link to="/mot-de-passe-oublie" className="text-[13px] text-navy-400 hover:text-navy-700 hover:underline">
              Mot de passe oublié ?
            </Link>
          </div>
        </form>

        <p className="text-center text-[12px] text-navy-300 mt-6">Hello Georges</p>
        <div className="flex items-center justify-center gap-3 mt-2 text-[12px] text-navy-300">
          <Link to="/mentions-legales" className="hover:text-navy-600 hover:underline">Mentions légales</Link>
          <span>·</span>
          <Link to="/confidentialite" className="hover:text-navy-600 hover:underline">Confidentialité</Link>
        </div>
      </div>
    </div>
  );
}
